import { render, staticRenderFns } from "./Bankscb.vue?vue&type=template&id=df8f8b12"
import script from "./Bankscb.vue?vue&type=script&lang=js"
export * from "./Bankscb.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports